import React from "react";
import { FaSearch } from "react-icons/fa";

const FiltersBar = ({
  cateEvents,
  eventTypes,
  searchEvent,
  setSearchEvent,
  dateFilter,
  setDateFilter,
  categoryFilter,
  setCategoryFilter,
  typeFilter,
  setTypeFilter,
  onlyWithRegistrations,
  setOnlyWithRegistrations,
}) => {
  return (
    <div className="px-5 py-5 sm:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-3 items-end">
        {/* Recherche (titre événement) */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
            Recherche (titre)
          </label>
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              value={searchEvent}
              onChange={(e) => setSearchEvent(e.target.value)}
              placeholder="Ex : Coupe, Open, Animation…"
              className="w-full rounded-xl pl-9 pr-3 py-2 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-violet-400"
            />
          </div>
        </div>

        {/* Date */}
        <div>
          <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
            Date
          </label>
          <select
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            <option value="all">Toutes</option>
            <option value="upcoming">À venir</option>
            <option value="past">Passées</option>
          </select>
        </div>

        {/* Catégorie */}
        <div>
          <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
            Catégorie
          </label>
          <select
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            <option value="">Toutes</option>
            {cateEvents.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        {/* Type */}
        <div>
          <label className="block text-sm font-medium text-slate-800 dark:text-slate-100 mb-1">
            Type
          </label>
          <select
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            <option value="">Tous</option>
            {eventTypes.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        </div>

        
      </div>
      {/* Switch “uniquement avec inscrits” */}
        <div className="flex items-center gap-3 h-6 mt-6 select-none">
          <button
            type="button"
            role="switch"
            aria-checked={onlyWithRegistrations}
            aria-label="Uniquement les événements avec inscrits"
            onClick={() => setOnlyWithRegistrations((v) => !v)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setOnlyWithRegistrations((v) => !v);
              }
            }}
            className={`relative inline-flex shrink-0 h-6 w-12 items-center rounded-full transition-colors
      focus:outline-none focus:ring-2 focus:ring-violet-400
      ${
        onlyWithRegistrations
          ? "bg-emerald-500"
          : "bg-slate-300 dark:bg-slate-700"
      }`}
          >
            <span
              className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform
        ${onlyWithRegistrations ? "translate-x-6" : "translate-x-1"}`}
            />
          </button>

          {/* Libellé sur une seule ligne (avec ellipse si trop long) */}
          <span className="text-sm overflow-hidden text-ellipsis whitespace-nowrap">
            Uniquement les événements avec inscrits
          </span>
        </div>
    </div>
  );
};

export default FiltersBar;
